import {ChangeDetectionStrategy, Component, Inject, Input} from "@angular/core";
import {INT_ICON_SPRITE_PATH_TOKEN, INT_ICON_SPRITE_VERSION} from "./int-icon-path.token";

@Component({
  selector: 'int-icon, [int-icon]',
  templateUrl: 'int-icon.component.html',
  styleUrls: ['int-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntIconComponent {
  @Input() name = '';
  @Input() size: string | number = '100%';
  @Input() box = '0 0 330 331';

  constructor(
    @Inject(INT_ICON_SPRITE_PATH_TOKEN) private readonly iconPath: string,
    @Inject(INT_ICON_SPRITE_VERSION) private readonly version: string
  ) {}

  get path(): string {
    return `${this.iconPath}?v=${this.version}#${this.name}`;
  }
}
